import { render, staticRenderFns } from "./BuildingRoomUsageReport.vue?vue&type=template&id=51177671&"
import script from "./BuildingRoomUsageReport.vue?vue&type=script&lang=js&"
export * from "./BuildingRoomUsageReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports